import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { SITE, img } from "../config";

export const Footer = () => (
    <footer className="mt-20 bg-[#2e2a1c] text-[#e8e3d3]" data-testid="site-footer">
        <div className="container-x grid gap-10 py-14 md:grid-cols-3">
            <div>
                <div className="flex items-center gap-2.5">
                    <img src={img("emblem")} alt="Atlanta Enclave logo" width="30" height="23" className="h-8 w-auto" loading="lazy" />
                    <span className="font-display text-lg font-semibold text-white">Atlanta Enclave Shilphata</span>
                </div>
                <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#b8b29b]">
                    Premium 1, 2 &amp; 3 BHK flats in Shilphata, Thane — an 8-acre gated community by Atlanta Limited, delivering quality since 1977.
                </p>
            </div>
            <nav aria-label="Footer navigation">
                <p className="eyebrow !text-[#b8a45e]">Explore</p>
                <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm">
                    <li><Link className="hover:text-white" to="/1-bhk/" data-testid="footer-link-1-bhk">Atlanta Enclave 1 BHK</Link></li>
                    <li><Link className="hover:text-white" to="/2-bhk/" data-testid="footer-link-2-bhk">Atlanta Enclave 2 BHK</Link></li>
                    <li><Link className="hover:text-white" to="/3-bhk/" data-testid="footer-link-3-bhk">Atlanta Enclave 3 BHK</Link></li>
                    <li><Link className="hover:text-white" to="/floor-plans/" data-testid="footer-link-floor-plans">Floor Plans</Link></li>
                    <li><Link className="hover:text-white" to="/amenities/" data-testid="footer-link-amenities">Amenities</Link></li>
                    <li><Link className="hover:text-white" to="/location/" data-testid="footer-link-location">Location</Link></li>
                    <li><Link className="hover:text-white" to="/contact/" data-testid="footer-link-contact">Contact</Link></li>
                </ul>
            </nav>
            <div>
                <p className="eyebrow !text-[#b8a45e]">Contact</p>
                <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed">
                    <MapPin size={15} className="mt-0.5 shrink-0" /> {SITE.address}
                </p>
                <p className="mt-3 flex items-center gap-2 text-sm">
                    <Phone size={15} className="shrink-0" />
                    <a href={SITE.phoneTel} className="font-bold hover:text-white" data-testid="footer-call-link">{SITE.phoneDisplay}</a>
                </p>
            </div>
        </div>
        <div className="border-t border-[#4a4430]">
            <div className="container-x flex flex-col gap-2 py-5 text-xs text-[#b8b29b] sm:flex-row sm:items-center sm:justify-between">
                <p>
                    MahaRERA Registration No: <strong className="text-[#e8e3d3]">{SITE.rera}</strong> —{" "}
                    <a href={SITE.reraPortal} target="_blank" rel="noopener noreferrer" className="underline hover:text-white" data-testid="footer-rera-link">
                        maharera.mahaonline.gov.in
                    </a>
                </p>
                <p>© {new Date().getFullYear()} Atlanta Enclave, a project by Atlanta Limited.</p>
            </div>
        </div>
    </footer>
);
